import { createContext } from 'react'

export interface IdeaActionsContextValue {
  generateFigmaPromptForIdea: (ideaNodeId: string) => void
  generateStoryboardForIdea: (ideaNodeId: string) => Promise<void>
  viewStoryboardNode: (storyboardNodeId: string) => void
  /**
   * Check if the idea's ancestor chain includes a venture with an audience defined
   * (the venture's "Who is it for?" or description). Required for storyboard generation.
   */
  hasVentureAudienceForIdea: (ideaNodeId: string) => boolean
}

export const IdeaActionsContext = createContext<IdeaActionsContextValue | null>(null)
